import React from 'react';

const FacebookIcon: React.FC<
  React.PropsWithChildren<React.SVGProps<SVGSVGElement>>
> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...props}
    >
      <g>
        <path
          fill="#4285F4"
          d="M20.102 21.016c2.808-2.621 4.058-6.996 3.308-11.18H12.23v4.621h6.372c-.25 1.5-1.125 2.75-2.375 3.563zm0 0"
        ></path>
        <path
          fill="#34A853"
          d="M1.613 17.332a11.988 11.988 0 008.348 6.332 12 12 0 0010.14-2.648l-3.874-2.996c-3.309 2.183-8.805 1.37-10.68-3.747zm0 0"
        ></path>
        <path
          fill="#FBBB02"
          d="M5.547 14.273c-.5-1.562-.5-3 0-4.562L1.613 6.652c-1.437 2.871-1.875 6.93 0 10.68zm0 0"
        ></path>
        <path
          fill="#EA4335"
          d="M5.547 9.71c1.375-4.308 7.246-6.808 11.18-3.12l3.437-3.375C15.29-1.47 5.797-1.281 1.614 6.652zm0 0"
        ></path>
      </g>
    </svg>
  );
};

export default FacebookIcon;
